var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0z M10,15.2c-0.4,0-0.8-0.3-0.8-0.8 c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8C10.8,14.9,10.4,15.2,10,15.2z M10.7,11.4v0.8c0,0.4-0.3,0.8-0.8,0.8c-0.4,0-0.8-0.3-0.8-0.8 v-1.5c0-0.4,0.3-0.8,0.8-0.8c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8c-0.6,0-1.2,0.3-1.5,0.8C8.3,7.4,8.3,7.6,8.2,7.7 C8.1,8.1,7.7,8.3,7.3,8.2C6.9,8.1,6.7,7.7,6.8,7.3C6.9,7,7,6.7,7.2,6.5C7.8,5.6,8.8,5,9.9,5c0,0,0,0,0,0h0c0,0,0,0,0,0 c1.8,0,3.3,1.5,3.3,3.2C13.2,9.8,12.2,11.1,10.7,11.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon_help.769cf2b55c4b202b582a7536e521f6e6.svg";
export { ForwardRef as ReactComponent };